import React from 'react';
import Font from '../Font/Font.js';

var HelveticaForTarget = function HelveticaForTarget(props) {
  var _a = props.variants,
      variants = _a === void 0 ? ['n4'] : _a,
      _b = props.formats,
      formats = _b === void 0 ? ['woff2', 'woff'] : _b,
      loaderConfig = props.loaderConfig;
  return React.createElement(Font, {
    fonts: ['Helvetica For Target'],
    variants: variants,
    formats: formats,
    loaderConfig: loaderConfig
  });
};

export default HelveticaForTarget;
